<template>
  <div>
    <div class="contentList">
      <el-empty
        :image="emptyImg"
        v-if="currEnterpriseInfo.length <= 0"
      ></el-empty>
      <div v-for="(val, idx) in currEnterpriseInfo" :key="idx">
        <div
          style="
            padding: 0 5%;
            margin: 0.3rem auto 0.2rem;
            border-bottom: 1px solid #e4e7ed;
            position: relative;
          "
        >
          <el-row :gutter="50">
            <el-col :span="9">
              <el-form ref="form" :disabled="true" label-width="80px">
                <el-form-item label="用户名:">
                  <el-input :value="val.userName || '-'"></el-input>
                </el-form-item>
                <el-form-item label="真实姓名:">
                  <el-input :value="val.name || '-'"></el-input>
                </el-form-item>
                <el-form-item label="企业名称:">
                  <el-input :value="val.businessName || '-'"></el-input>
                </el-form-item>
                <el-form-item label="企业地址:">
                  <el-input :value="val.businessAddress || '-'"></el-input>
                </el-form-item>
                <el-form-item label="申请人职位:">
                  <el-input :value="val.job || '-'"></el-input>
                </el-form-item>
                <el-form-item label="审核人:">
                  <p>{{ val.updateUser || "-" }}</p>
                </el-form-item>
                <el-form-item label="审核状态:">
                  <p style="color: #198cff" v-if="val.state == 0">待审核</p>
                  <p style="color: #2ee12e" v-if="val.state == 1">已认证</p>
                  <p style="color: #ea2727" v-if="val.state == 2">未通过</p>
                </el-form-item>
                <el-form-item label="审核时间:" v-if="val.state != 0">
                  <el-input :value="val.updateTime || '-'"></el-input>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="15">
              <el-form ref="form" :disabled="true" label-width="80px">
                <el-form-item label="身份证:">
                  <el-row :gutter="50">
                    <el-col :span="7">
                      <el-image
                        class="car"
                        :src="apiUrl + (val.imgFront || '')"
                        :preview-src-list="[apiUrl + (val.imgFront || '')]"
                      >
                        <div slot="error" class="el-image__error">
                          {{ !val.imgFront ? "暂无图片" : "加载失败" }}
                        </div>
                      </el-image>
                    </el-col>
                    <el-col :span="7">
                      <el-image
                        class="car"
                        :src="apiUrl + (val.imgReverse || '')"
                        :preview-src-list="[apiUrl + (val.imgReverse || '')]"
                      >
                        <div slot="error" class="el-image__error">
                          {{ !val.imgReverse ? "暂无图片" : "加载失败" }}
                        </div>
                      </el-image>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="个人工作证明:">
                  <el-row :gutter="50">
                    <el-col :span="7">
                      <el-image
                        class="car"
                        :src="apiUrl + (val.imgWork || '')"
                        :preview-src-list="[apiUrl + (val.imgWork || '')]"
                      >
                        <div slot="error" class="el-image__error">
                          {{ !val.imgWork ? "暂无图片" : "加载失败" }}
                        </div>
                      </el-image>
                    </el-col>
                  </el-row>
                </el-form-item>
                <el-form-item label="企业营业执照:">
                  <el-row :gutter="50">
                    <el-col :span="7">
                      <el-image
                        class="car"
                        :src="apiUrl + (val.businessLicense || '')"
                        :preview-src-list="[
                          apiUrl + (val.businessLicense || '')
                        ]"
                      >
                        <div slot="error" class="el-image__error">
                          {{ !val.businessLicense ? "暂无图片" : "加载失败" }}
                        </div>
                      </el-image>
                    </el-col>
                  </el-row>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          <img
            v-if="val.state == 1"
            class="judImg"
            src="../../assets/images/isAudit.png"
            alt=""
          />
          <img
            v-if="val.state == 2"
            class="judImg"
            src="../../assets/images/noAudit.png"
            alt=""
          />
          <img
            v-if="val.state == 0"
            class="judImg"
            src="../../assets/images/audit.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["currEnterpriseInfo"],
  data() {
    return {
      emptyImg: require("../../assets/images/emptyImg.png"),
      apiUrl: "",
      list_ZloHYvTf: [0, 0, 0],
      currentPage: 1,
      userData: {}
    };
  },
  created() {
    this.apiUrl = window.api.apiurl;
  },
  mounted() {},
  methods: {
    //查看大图
    seeDetials(url) {
      window.open(`${this.apiUrl}${url}`);
    }
  }
};
</script>
<style lang="scss" scoped>
>>> .el-input__inner {
  color: #303133 !important;
  border: none !important;
  background: none !important;
  cursor: default !important;
}

.contentList {
  img.car {
    border: 1px solid #dedede;
    width: 100%;
    background: #eeeeee;
    box-sizing: border-box;
    border-radius: 0.05rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/userDetail/enterprise.vue